import axios from 'axios';

import LocalidadTabla from '../types/LocalidadTabla';


async function GuardarLocalidad(prmLocalidad: LocalidadTabla) {
    
    const url = "https://endpoints.mapsys.com.ar/gestion/guardar_localidad"
    
    try {
        const response = await axios.post(url, {
            "usuario": "mpatti",
            "clave": "all2GetHer_!",
            "localidad": {
                "id": prmLocalidad.id,
                "codpostal": prmLocalidad.codpostal,
                "localidad": prmLocalidad.localidad,
                "habilitado": prmLocalidad.habilitado,
                "fch_modi": prmLocalidad.fch_modi,
                "dado_baja": prmLocalidad.dado_baja,
                "fch_baja": prmLocalidad.fch_baja,
                "id_pais": prmLocalidad.pais_id,
                "id_provincia": prmLocalidad.provincia_id
            }
        });
        return response.data;
    } catch (error) {
        return error;
    }
};

export default GuardarLocalidad;